import { AsyncPipe, NgComponentOutlet, NgForOf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ComponentByTaskPipe } from './pipes/component-by-task.pipe';
import { TasksQueueStoreModule } from './store/tasks-queue-store.module';
import { selectTasks } from './store/tasks-queue.feature';
import { ITask } from './store/tasks-queue.types';

@Component({
  selector: 'app-tasks-queue',
  templateUrl: 'tasks-queue.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TasksQueueStoreModule,
    ComponentByTaskPipe,
    NgForOf,
    AsyncPipe,
    NgComponentOutlet,
  ],
})
export class TasksQueueComponent implements OnInit {
  public tasks$: Observable<ITask[]>;

  private readonly store = inject(Store);

  public ngOnInit(): void {
    this.tasks$ = this.store.select(selectTasks);
  }
}
